import { useState } from 'react';
import { noop } from 'utils/noop';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { InputText } from 'ui/inputs';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { body2, colors, spacing, subtitle2 } from 'ui/theme';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { copyWorkflowWebhookRequest } from '../actions';

// type Props = {
//   workflowWebhook: WorkflowWebhook,
//   /** Function run to close the modal */
//   onClose: () => void,
//   /** Function run to refetch data, used after copying workflow webhook */
//   refetch: () => void,
// };

const ModalBodyText = styled.p`
  ${body2}
`;

export const WorkflowWebhookNameLabel = styled.label`
  ${subtitle2};
  color: ${colors.grey80};
`;

export const WorkflowWebhookNameInput = styled(InputText)`
  width: ${spacing.x36};
`;

const content = {
  modalHeader: 'Copy webhook?',
  confirmAction: 'Copy webhook',
};

export const CopyWorkflowWebhookModal = ({ workflowWebhook, onClose = noop, refetch = noop }) => {
  const dispatch = useDispatch();
  const [webhookName, setWebhookName] = useState(`Copy of ${workflowWebhook.name}`);
  const handleConfirmCopy = () => {
    dispatch(
      copyWorkflowWebhookRequest(workflowWebhook, webhookName, () => {
        onClose();
        refetch();
      }),
    );
  };

  return (
    <Modal
      id="copy-workflow-webhook-modal"
      onClose={onClose}
      data-test="copy-workflow-webhook-modal"
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>{content.modalHeader}</ModalHeader>
      <ModalBody>
        <ModalBodyText>
          The copy of <b>{workflowWebhook.name}</b> will have the same configuration as the
          original—except for authentication settings, which you’ll need to set up again.
        </ModalBodyText>
        <WorkflowWebhookNameLabel>New webhook name</WorkflowWebhookNameLabel>
        <WorkflowWebhookNameInput value={webhookName} onChange={setWebhookName} autoFocus />
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          data-test="confirm-copy-workflow-webhook-button"
          size={BUTTON_SIZES.LARGE}
          onClick={handleConfirmCopy}
          isDisabled={webhookName.length === 0}
        >
          {content.confirmAction}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
